import { FC } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, emitScrollTo } from '@ebsco-ui/ebsco-ui';

import { setFocusOn } from '@app/utils';

import css from './BackToTopButton.module.scss';

interface BackToTopButtonProps {
  isVisible: boolean;
}

const scrollToTop = () => {
  setFocusOn();
  emitScrollTo(0, undefined);
};

export const BackToTopButton: FC<BackToTopButtonProps> = ({ isVisible }) => {
  const { $t } = useIntl();

  return (
    <Button
      data-auto="back-to-top-button"
      aria-label={$t({
        id: 'messages.backToTop',
        defaultMessage: 'Back to top',
      })}
      className={cn(css.backToTopButton, { [css.visible]: isVisible })}
      styleType="solid"
      onClick={scrollToTop}
    >
      <FontAwesomeIcon icon={faArrowUp} className={css.icon} />
    </Button>
  );
};
